import { lazyLoad } from 'utils/loadable';

export const CouponUsageReport = lazyLoad(() => import('./index'));
